import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'mom-validation-text',
  templateUrl: 'validation-text.component.html',
  styleUrls: ['validation-text.component.scss']
})
export class ValidationTextComponent {
  @Input() formCtrl: AbstractControl;
}
